import { Box, Stack } from "@mui/material"
import { TLandingTextImg } from "./types"
import { Header } from "cakemail-ui-components-v2"
import "./styles.scss"

export function LandingTextImg({ reversed, imgSrc, support, title, desc }: TLandingTextImg) {

    const content: any[] = [
        <Box key="landing-txt-img-1">
            <Header
                support={support}
                heading={title}
                headingVariant="headlineL"
                desc={desc}
            />
        </Box>,
        <img key="landing-txt-img-2" src={imgSrc} />
    ]

    if (reversed)
        content.reverse()

    return <Stack className="loadingTxtImg" direction={{ mobile: !reversed ? 'column-reverse' : "column", xs: 'row' }} gap={16} justifyContent="space-between" flex="1">
        {content}
    </Stack>
}